module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Biel-Benken-712774cf75fb35c478eee4ac464b6c50.svg";